"use client";
import Image, { StaticImageData } from "next/image";
import { AspectRatio, Center, Heading, SimpleGrid, VStack } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import { DATA_CENTER_CONSTANTS, PLANNED_SERVICE_LOCATIONS } from "./constants";
import DataCenterLocation from "./dataCenterLocation";

type Props = {
  locations: { id: number; image: StaticImageData; name: string }[];
};

const LocationsLayout = (props: Props) => {
  const { locations } = props;
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={6} w={"full"}>
      {locations.map((item) => {
        const { id, image, name } = item;
        return (
          <VStack key={id}>
            <AspectRatio position="relative" ratio={2 / 1} w="full">
              <Image
                alt={name}
                fill
                src={image}
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
            </AspectRatio>
            <Heading as="h3" variant={HEADING_VARIANTS.SUBTITLE3}>
              {name}
            </Heading>
          </VStack>
        );
      })}
    </SimpleGrid>
  );
};

const PlannedServiceLocations = () => {
  return <LocationsLayout locations={PLANNED_SERVICE_LOCATIONS} />;
};

export const tablist = [
  {
    component: DataCenterLocation,
    label: () => (
      <Center>
        <Heading fontWeight={600} variant={HEADING_VARIANTS.SUBTITLE3}>
          {DATA_CENTER_CONSTANTS.ACTIVE_SERVICE_LOCATION}
        </Heading>
      </Center>
    ),
  },
  {
    component: PlannedServiceLocations,
    label: () => (
      <Center>
        <Heading fontWeight={600} variant={HEADING_VARIANTS.SUBTITLE3}>
          {DATA_CENTER_CONSTANTS.PlANNED_SERVICE_LOCATIONS}
        </Heading>
      </Center>
    ),
  },
];
